import { useState } from "react";
import { ReactComponent as FaqIcon } from "./../assets/svgs/faq-icon.svg";

const FaqItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-b border-[#CCC9C6]">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between py-3 text-left"
      >
        <span className="text-[#1A1A1A] font-normal text-[13px] md:text-[14px] leading-[28px] tracking-[0.17px] align-middle font-inter">
          {q}
        </span>
        <span className="text-[#9A9A9A] text-[12px] md:text-[13px] leading-none">
          {open ? <span className="text-[30px]">−</span> : <FaqIcon />}
        </span>
      </button>

      {open && (
        <div className="pb-4 pr-6 text-[13px] leading-[16px] text-[#6D6D6D] whitespace-pre-line">
          {a}
        </div>
      )}
    </div>
  );
};

export default FaqItem;
